import {createContext, useContext} from 'react'
import {useDisclosure} from '../../vanilla'

export const ExitOrderEditModeModalContext = createContext<ReturnType<typeof useDisclosure> | null>(
  null
)

export const useExitEditModeModal = () => useContext(ExitOrderEditModeModalContext)
